import React from 'react';

const Drinks = React.forwardRef(({ onConsultationClick }, ref) => {
  return (
    <section ref={ref} id="drinkMenu" className=" p-8 text-center">

<h2 className="h2 text-4xl font-bold">Web Design</h2>
<p className="pretitle text-lg">All Included</p>
<div className='grid grid-row'>
<span>The aim of GoHost is to create the most appealing website possible, <span className='pretitle'>FREE OF CHARGE</span></span>
<br/>
<span>Keeping your website top of the line in the restaurant industry is our standard. We believe in an increasing value of online impressions and intend to capitalize on this whenever possible with our builds.</span>
</div>
<br/> 
<span><span
  onClick={onConsultationClick}
  title="Click to exit and request consultation"
  className="underline cursor-pointer pretitle hover:text-accent transition-colors duration-200"
>In our consultation</span> we will deep dive into the online asthetic your restaurant aligns with, and suggest a few innovative looks of our own. Once we have a plan, GoHost queries various well established Graphic Designers and determines which can best suit your restaurant's 3D portrayal appeal for your reservation process.</span>
<br/>
<br/>
<span>The Gohost Model is that when you win, we win. Because of this, we trend towards website frames that have been proven to optimize customer engagement.  </span>
<br/>
<span>However...</span>
<br/>
<span>1. We will work to tailor every aspect of your website to your branding needs.</span>
<br/>
<span>2. If you desire a complex but vital custom feature on your website, this can be negotiated into an inital build fee</span>
<div className=" h9 text-neutral-700 italic underline mt-8 mb-3 ">
Free Wesbite Features </div>
<div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
<div className='flex capitalize items-center justify-center p-4 text-neutral-600 border border-neutral-300 rounded-md'>Custom made or exsiting logo usage</div>
<div className='flex capitalize items-center justify-center p-4 text-neutral-600 border border-neutral-300 rounded-md'>Color and font scheme branding</div>
<div className='flex capitalize items-center justify-center p-4 text-neutral-600 border border-neutral-300 rounded-md'>Descritpive texts for restaurant information</div>
<div className='flex capitalize items-center justify-center p-4 text-neutral-600 border border-neutral-300 rounded-md'>Professional 3D Portrayal of restaurant layout </div>
<div className='flex capitalize items-center justify-center p-4 text-neutral-600 border border-neutral-300 rounded-md'>Online Reservations with built in optional (free!) PreOrdering capabilities</div>
<div className='flex capitalize items-center justify-center p-4 text-neutral-600 border border-neutral-300 rounded-md'>Themed Header with site menu navigation</div>
<div className='flex capitalize items-center justify-center p-4 text-neutral-600 border border-neutral-300 rounded-md'>Header and Footer Social Media links + automatically updating hours & contact</div>
<div className='flex capitalize items-center justify-center p-4 text-neutral-600 border border-neutral-300 rounded-md'>Fully Customizeable Menu with pictures wherever desired</div>
<div className='flex capitalize items-center justify-center p-4 text-neutral-600 border border-neutral-300 rounded-md'>Restaurant "About" + "Background" or "Story" sections</div>
</div>
    </section>
  );
});

export default Drinks;
